<div class="container">
  <div class="container-header">
    <!-- Header -->
    <div class="header">
        <div class="sub-container flex-box">
            <div class="left">
                <img class="logo" src="../../../../../assets/img/logo.png" alt="">
                <p class="title">Angkor Pass</p>
            </div>
            <div class="spacer"></div>
        </div>
    </div>
</div>
    <div class="container-content">
        <h1>Privacy Policy</h1>
        <p>
            Thank you for choosing to be part of our community at Angkor Enterprise ("
            <span class="bold"> Company </span>", "<span class="bold"> we </span
            >", "<span class="bold">us</span>", "<span class="bold">our</span>"). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy notice, or our practices with
            regards to your personal information, please contact us at support@angkorenterprise.gov.kh.
        </p>

        <p>
            When you use our mobile application, as the case may be (the "<span class="bold">App</span
            >") and more generally, use any of our services (the "<span class="bold"
              >Services</span
            >", which include the App ), we appreciate that you are trusting us with
            your personal information. We take your privacy very seriously. In this
            privacy notice, we seek to explain to you in the clearest way possible
            what information we collect, how we use it and what rights you have in
            relation to it. We hope you take some time to read through it carefully,
            as it is important. If there are any terms in this privacy notice that
            you do not agree with, please discontinue use of our Services
            immediately.
          </p>

          <p>
            This privacy notice applies to all information collected through our
            Services (which, as described above, includes our App ), as well as, any
            related services, sales, marketing or events.
          </p>

          <strong class="note"
            >Please read this privacy notice carefully as it will help you
            understand what we do with the information that we collect.</strong
          >
        <ul class="list">
            <li>
              <h3>1. WHAT INFORMATION DO WE COLLECT?</h3>

              <h4 class="bold">Personal information you disclose to us</h4>
              <p class="italic">
                <span class="note bold">In Short:</span> We collect personal information that you provide to us.
        </p>

        <p>
            We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services, when you participate in activities on the App (such as by posting messages in our online forums
            or entering competitions, contests or giveaways) or otherwise when you contact us.
        </p>

        <p>
            The personal information that we collect depends on the context of your interactions with us and the App , the choices you make and the products and features you use. The personal information we collect may include the following:
        </p>

        <h4>Information collected through our App</h4>
        <p class="italic">
            <span class="note bold">In Short:</span> We collect information regarding your mobile device, push notifications, when you use our App.
        </p>

        <p>If you use our App, we also collect the following information:</p>
        <ul class="sub-list">
            <li>
                <span class="italic">Push Notifications.</span> We may request to send you push notifications regarding your account or certain features of the App. If you wish to opt-out from receiving these types of communications, you may turn them
                off in your device's settings.
            </li>
        </ul>

        <p>
            This information is primarily needed to maintain the security and operation of our App, for troubleshooting and for our internal analytics and reporting purposes.
        </p>
        </li>

        <li>
            <h3>2. HOW DO WE USE YOUR INFORMATION?</h3>

            <p class="italic">
                <span class="note bold">In Short:</span> We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.
            </p>

            <p>
                We use personal information collected via our App for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract
                with you, with your consent, and/or for compliance with our legal obligations. We indicate the specific processing grounds we rely on next to each purpose listed below.
            </p>

            <p>We use the information we collect or receive:</p>

            <ul class="sub-list">
                <li>To deliver schedule, fulfill and manage customer emails.</li>
                <li>To notify you to check and remind you about your events.</li>
            </ul>
        </li>

        <li>
            <h3>3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</h3>

            <p class="italic">
                <span class="note bold">In Short:</span> We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.
            </p>

            <ul class="sub-list">
                <li>
                    <span class="bold">Consent:</span> We may process your data if you have given us specific consent to use your personal information for a specific purpose.
                </li>
                <li>
                    <span class="bold">Legitimate Interests:</span> We may process your data when it is reasonably necessary to achieve our legitimate business interests.
                </li>
                <li>
                    <span class="bold">Performance of a Contract:</span> Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.
                </li>
                <li>
                    <span class="bold">Legal Obligations:</span> We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process,
                    such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements).
                </li>
                <li>
                    <span class="bold">Vital Interests:</span> We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving
                    potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved.
                </li>
            </ul>

            <p>
                More specifically, we may need to process your data or share your personal information in the following situations:
            </p>
            <ul class="sub-list">
                <li>
                    <span class="bold">Business Transfers.</span> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business
                    to another company.
                </li>
            </ul>
        </li>

        <li>
            <h3>4. HOW LONG DO WE KEEP YOUR INFORMATION?</h3>

            <p class="italic">
                <span class="note bold">In Short:</span> We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.
            </p>

            <p>
                We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). No purpose
                in this notice will require us keeping your personal information for longer than 2 years .
            </p>

            <p>
                When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives),
                then we will securely store your personal information and isolate it from any further processing until deletion is possible.
            </p>
        </li>

        <li>
            <h3>5. HOW DO WE KEEP YOUR INFORMATION SAFE?</h3>

            <p class="italic">
                <span class="note bold">In Short:</span> We aim to protect your personal information through a system of organizational and technical security measures.
            </p>

            <p>
                We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission
                over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security, and improperly
                collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our App is at your own risk. You should only access the App within
                a secure environment.
            </p>
        </li>

        <li>
            <h3>6. WHAT ARE YOUR PRIVACY RIGHTS?</h3>

            <p class="italic">
                <span class="note bold">In Short:</span> You may review, change, or terminate your account at any time.
            </p>

            <p>
                If you are a resident in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here:
                <a href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a
                >.
              </p>

              <p>
                If you are a resident in Switzerland, the contact details for the
                data protection authorities are available here:
                <a href="https://www.edoeb.admin.ch/edoeb/en/home.html"
                  >https://www.edoeb.admin.ch/edoeb/en/home.html</a
                >.
              </p>
            </li>

            <li>
              <h3>7. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>

              <p>
                Most web browsers and some mobile operating systems and mobile
                applications include a Do-Not-Track ("DNT") feature or setting you
                can activate to signal your privacy preference not to have data
                about your online browsing activities monitored and collected. At
                this stage no uniform technology standard for recognizing and
                implementing DNT signals has been finalized. As such, we do not
                currently respond to DNT browser signals or any other mechanism that
                automatically communicates your choice not to be tracked online. If
                a standard for online tracking is adopted that we must follow in the
                future, we will inform you about that practice in a revised version
                of this privacy notice.
              </p>
            </li>

            <li>
              <h3>8. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h3>

              <p class="italic">
                <span class="note bold">In Short:</span> Yes, if you are a resident
                of California, you are granted specific rights regarding access to
                your personal information.
              </p>

              <p>
                California Civil Code Section 1798.83, also known as the "Shine The
                Light" law, permits our users who are California residents to
                request and obtain from us, once a year and free of charge,
                information about categories of personal information (if any) we
                disclosed to third parties for direct marketing purposes and the
                names and addresses of all third parties with which we shared
                personal information in the immediately preceding calendar year. If
                you are a California resident and would like to make such a request,
                please submit your request in writing to us using the contact
                information provided below.
              </p>

              <p>
                If you are under 18 years of age, reside in California, and have a
                registered account with the App , you have the right to request
                removal of unwanted data that you publicly post on the App . To
                request removal of such data, please contact us using the contact
                information provided below, and include the email address associated
                with your account and a statement that you reside in California. We
                will make sure the data is not publicly displayed on the App , but
                please be aware that the data may not be completely or
                comprehensively removed from all our systems (e.g. backups, etc.).
              </p>
            </li>

            <li>
              <h3>9. DO WE MAKE UPDATES TO THIS NOTICE?</h3>

              <p class="italic">
                <span class="note bold">In Short:</span> Yes, we will update this
                notice as necessary to stay compliant with relevant laws.
              </p>

              <p>
                We may update this privacy notice from time to time. The updated
                version will be indicated by an updated "Revised" date and the
                updated version will be effective as soon as it is accessible. If we
                make material changes to this privacy notice, we may notify you
                either by prominently posting a notice of such changes or by
                directly sending you a notification. We encourage you to review this
                privacy notice frequently to be informed of how we are protecting
                your information.
              </p>
            </li>

            <li>
              <h3>10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>

              <p>
                If you have questions or comments about this notice, you may email
                us at support@angkorenterprise.gov.kh or by post to:
              </p>

              <div class="address">
                <p>Angkor Enterprise</p>
                <p>Phone : (+855) 63 965 414</p>
                <p>Email : support@angkorenterprise.gov.kh</p>
                <p>Address : Circle Apsara Circle (Angkor Kyung Yu) Street 60m, Treang Village, Sangkat Slor Kram, Siem Reap Town, Siem Reap Province</p>
              </div>
            </li>
          </ul>
    </div>
</div>
